import { track, BRAND } from './shared';
import { centsAsDecimal } from '../utils/money';

const productAvailability = ({ productOutOfStock }) => (productOutOfStock ? 'Out Of Stock' : 'In Stock');

const productProperties = () => {
  const priceSection = document.getElementById('above-the-fold-price-section');

  if (!priceSection) return {};

  const { variantId } = priceSection.dataset;
  const {
    productId, productTitle, price, variantTitle, productType, variantSku, productOutOfStock
  } = window.variantDataSelector.getData(variantId);

  return {
    brand: BRAND,
    category: productType,
    currency: 'USD',
    product_id: productId,
    variant_id: variantId,
    last_product_viewed: productTitle,
    name: productTitle,
    variant: variantTitle || 'Default Title',
    sku: variantSku,
    price: centsAsDecimal(price),
    product_availability: productAvailability({ productOutOfStock }),
    products_viewed: 1,
    quantity: 1
  };
};

const productViewed = () => {
  track({
    eventName: 's_track',
    data: {
      s_event: 'Product Viewed',
      s_properties: productProperties()
    }
  });
};

export default productViewed;
